export default "__VITE_ASSET__Bkdxt0Vu__"